module.exports = __webpack_public_path__ + "images/avatars/male/1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/1.png
// module id = l8ep
// module chunks = 154